import { baseApi, extractData } from "../api/axiosConfig";


export const getAllBatches = () =>
    baseApi
        .get("/batch")
        .then(extractData);


export const addBatch = data =>
    baseApi
        .post("/batch", data)
        .then(extractData);


export const editBatch = (batchId, data) =>
    baseApi
        .patch(`/batch/${batchId}`, data)
        .then(extractData);


export const deleteBatch = batchId =>
    baseApi
        .delete(`/batch/${batchId}`)
        .then(extractData);